<template>
    <div class="home">
        <b-container fluid>
            <h1 class="mb-4" v-if="$keycloak.authenticated">{{$keycloak.fullName}}'s Dashboard</h1>

            <b-row class="mt-4 mb-4" v-if="!$keycloak.authenticated">
                <b-col>
                    Welcome to the Online Storefront.
                </b-col>
            </b-row>
            <b-row class="mt-4 mb-4" v-if="$keycloak.authenticated && hasRole('user')">
                <b-col>
                    <Dashboard v-on:order-emit="$emit('update-order')"></Dashboard>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
import Dashboard from "./Dashboard";

export default {
  components: {
      Dashboard,
  },
  data: () => ({
  }),
  
  computed: {
    userRole() {
      return this.$store.state.userRole
    },
  },

  mounted() {
  },

  methods: {
      hasRole(roles) {
          if (this.$keycloak) {
              return this.$keycloak.hasResourceRole(roles)
          } else {
              return false;
          }
      },
      showRootToast(title, message, type) {
          this.$root.$bvToast.toast(message, {
              title: title,
              toaster: 'b-toaster-top-center',
              solid: true,
              variant: type,
              appendToast: true,
              noAutoHide:true
          })
          this.toastFocus()
      },
      toastFocus() {
          setTimeout(() => {
              let elem = document.getElementsByClassName("toast")
              elem = elem[elem.length-1]
              elem.focus()
          }, 100)
      },
  },
  created() {
    document.title = "Dashboard - Online Storefront"
  },

}
</script>

<style>
 .green-header {
     color: #60A609;
 }
</style>
